import type { MatchedBudgetLine, TemplateMatch } from "@/lib/match-offer-line-templates";
import type { OfferLineTemplate } from "@/hooks/use-offers";

/**
 * Sett valgt mal (eller fjern) på en importert linje, og utled effektiv
 * phase/cost_type. Ren funksjon uten React- eller Supabase-avhengigheter
 * (kun type-imports) — testbar isolert, og holder ImportLineReviewStep fri for
 * react-refresh-advarsler.
 *
 * VIB-1136: mal-match rettes i import-popupen, ikke i tilbudseditoren.
 */
export function applyTemplateToLine(
  line: MatchedBudgetLine,
  template: OfferLineTemplate | null,
): MatchedBudgetLine {
  if (!template) {
    // Fjern mal-kobling og gjenopprett de parser-baserte effektive verdiene
    // (samme heuristikk som enrichBudgetLines bruker for umatchede linjer),
    // ellers ville linjen beholdt stille mal-deriverte phase/cost_type i DB.
    return {
      ...line,
      template_match: null,
      effective_phase: line.phase,
      effective_cost_type: line.has_time ? "internal" : "external",
    };
  }
  const match: TemplateMatch = {
    template_id: template.id,
    template_name: template.name,
    phase: template.phase,
    cost_type: template.cost_type,
    pricing_type: template.pricing_type,
    default_unit: template.default_unit,
  };
  const effective_cost_type: "internal" | "external" =
    template.cost_type === "external" ? "external" : "internal";
  return {
    ...line,
    template_match: match,
    effective_phase: template.phase,
    effective_cost_type,
  };
}
